/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import cx from 'classnames';
import { ExpandableLink, ArrowLink, Modal, TypographyWrapper } from '@bwoty-web/ui-kit';
import { logGeoInformation } from '../utils/log';
import { scrollUpToElementIfNeeded } from '../utils/elements';
import Paragraph from './paragraph';
import './description.scss';

const Paragraphs = ({ paragraphs, isExpanded }) => {
  return (
    <TypographyWrapper className="gw-description__paragraphs">
      {paragraphs.map((paragraph) => {
        return (
          <Paragraph
            paragraph={paragraph}
            isExpanded={isExpanded}
            key={uniqid('description-paragraph-')}
          />
        );
      })}
    </TypographyWrapper>
  );
};

const Description = ({
  paragraphs,
  mobileHeading,
  geoType,
  showMoreText,
  hideText,
  className = null,
  isAlwaysExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(isAlwaysExpanded);

  if (paragraphs?.length < 1) {
    return null;
  }

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
    logGeoInformation.clickOnMoreAbout(isExpanded, geoType);
    const [containerElement] =
      document.getElementsByClassName('gw-description');
    scrollUpToElementIfNeeded(containerElement);
  };

  let isMobile = false;

  if (typeof window !== 'undefined') {
    isMobile = window?.innerWidth < 768;
  }

  const expandedMobile = isMobile && isExpanded;

  return (
    <div className={cx(className, 'gw-description')}>
      <Paragraphs
        paragraphs={paragraphs}
        isExpanded={isAlwaysExpanded || (isExpanded && !isMobile)}
      />
      {!isAlwaysExpanded && paragraphs?.length > 1 && (
        <>
          <ExpandableLink
            className="gw-description__expand-link--desktop"
            isOpen={isExpanded}
            onClick={() => handleExpand()}
          >
            {isExpanded ? `${hideText}` : `${showMoreText}`}
          </ExpandableLink>
          <ArrowLink
            className="gw-description__expand-link--mobile"
            onClick={() => handleExpand()}
            aria-haspopup="dialog"
          >
            {showMoreText}
          </ArrowLink>
        </>
      )}
      {!isAlwaysExpanded && expandedMobile && (
        <Modal
          className="gw-description__pop-up"
          heading={mobileHeading}
          onClose={() => handleExpand()}
          isOpen={isExpanded}
        >
          <div className="gw-description__pop-up-content">
            <Paragraphs paragraphs={paragraphs} isExpanded />
          </div>
        </Modal>
      )}
    </div>
  );
};

Description.propTypes = {
  paragraphs: PropTypes.arrayOf(
    PropTypes.shape({
      mobile: PropTypes.string,
      desktop: PropTypes.string,
      expanded: PropTypes.string,
      heading: PropTypes.string,
    }),
  ).isRequired,
  showMoreText: PropTypes.string.isRequired,
  hideText: PropTypes.string.isRequired,
  geoType: PropTypes.string.isRequired,
  mobileHeading: PropTypes.node.isRequired,
  className: PropTypes.string,
  isAlwaysExpanded: PropTypes.bool,
};

export default Description;
